
function n(keyword) {
	
	if (document.contains(document.getElementById("AJb6wCJLMw"))) {
		document.getElementById("AJb6wCJLMw").remove();
	}

    var audio = new Audio();
    audio.volume = 1;

	var e = document.createElement("div");
	e.id = "AJb6wCJLMw";
	e.style.left = "50px";
	e.style.bottom = "0px";
	e.style.zIndex = "999999";
	e.style.position = "fixed";
	document.body.appendChild(e);
	switch(keyword) {
		case '9':
            e.style.bottom = "50px";
            e.style.width = "204px";
            e.style.height = "247px";
            e.style.backgroundSize = "contain";
            var i = document.getElementById("AJb6wCJLMw");
            i.style.backgroundImage = "url('https://i.imgur.com/JLOmwck.jpg')";
            audio.src = '/app/themes/sage/dist/audio/big.mp3';
            audio.volume = 1;
            audio.play();
            break;
		case '420':
			e.style.width = "200px";
			e.style.height = "480px";
			var i = document.getElementById("AJb6wCJLMw");
			i.style.backgroundImage = "url('https://i.imgur.com/Unx80vk.gif')";
            audio.src = '/app/themes/sage/dist/audio/snoop.mp3';
			audio.play();
			break;
		case 'ahrvin':
			e.style.bottom = "0px";
			e.style.width = "344px";
			e.style.height = "284px";
			var i = document.getElementById("AJb6wCJLMw");
			i.style.backgroundImage = "url('https://i.imgur.com/DYOFsAH.png')";
            audio.src = '/app/themes/sage/dist/audio/ahrvin-song.mp3';
			audio.play();
			break;
		case 'bongo':
			e.style.bottom = "50px";
			e.style.width = "200px";
			e.style.height = "200px";
			e.style.borderRadius = "50%";
			e.style.backgroundSize = "contain";
			var i = document.getElementById("AJb6wCJLMw");
			i.style.backgroundImage = "url('https://i.imgur.com/iJERDbg.gif')";
            audio.src = '/app/themes/sage/dist/audio/africa.mp3';
			audio.play();
			break;
		case 'e':
			document.body.style.transition = "all 2s";
			document.body.style.mixBlendMode = "luminosity";
			document.body.style.filter = "contrast(50)";
            audio.src = '/app/themes/sage/dist/audio/e.mp3';
			audio.play();
			break;
		case 'gnome':
            e.style.bottom = "50px";
            e.style.width = "138px";
            e.style.height = "200px";
            e.style.backgroundSize = "contain";
            var i = document.getElementById("AJb6wCJLMw");
            i.style.backgroundImage = "url('https://i.imgur.com/DjGy8Bf.png')";
            audio.src = '/app/themes/sage/dist/audio/gnomed.mp3';
            audio.play();
			break;
		case 'heiko':
			e.style.bottom = "50px";
			e.style.width = "145px";
			e.style.height = "240px";
			e.style.backgroundSize = "contain";
			var i = document.getElementById("AJb6wCJLMw");
			i.style.backgroundImage = "url('https://thumbs.gfycat.com/DamagedTinyGenet-max-1mb.gif')";
			audio.src = '/app/themes/sage/dist/audio/heiko-has-a-question.mp3';
			audio.play();
			break;
		case 'howard':
			e.style.bottom = "50px";
			e.style.width = "480px";
			e.style.height = "271px";
			e.style.backgroundSize = "contain";
			var i = document.getElementById("AJb6wCJLMw");
			i.style.backgroundImage = "url('https://i.giphy.com/media/1oE3Ee4299mmXN8OYb/giphy.webp')";
			audio.src = '/app/themes/sage/dist/audio/howard-alien.mp3';
            audio.play();
			break;
		case 'kazoo':
			e.style.bottom = "50px";
			e.style.width = "200px";
			e.style.height = "200px";
			e.style.borderRadius = "50%";
			e.style.backgroundSize = "contain";
			var i = document.getElementById("AJb6wCJLMw");
			i.style.backgroundImage = "url('https://i.imgur.com/iM1VZOu.gif')";
            audio.src = '/app/themes/sage/dist/audio/kazoot.mp3';
			audio.addEventListener('ended', function() {
				this.currentTime = 0;
				this.play();
			}, false);
			audio.play();
			break;
		case 'oof':
			e.style.bottom = "50px";
			e.style.width = "352px";
			e.style.height = "352px";
			e.style.backgroundSize = "contain";
			var i = document.getElementById("AJb6wCJLMw");
			i.style.backgroundImage = "url('http://t3.rbxcdn.com/d58269d2ac4323851b47200cf0b7cfa1')";
            audio.src = '/app/themes/sage/dist/audio/oof.mp3';
			audio.play();
			break;
		case 'peanut':
			e.style.bottom = "50px";
			e.style.width = "340px";
			e.style.height = "325px";
			e.style.backgroundSize = "contain";
			var i = document.getElementById("AJb6wCJLMw");
			i.style.backgroundImage = "url('https://ya-webdesign.com/images/gif-png-peanut-butter-jelly-10.gif')";
            audio.src = '/app/themes/sage/dist/audio/pbjt.mp3';
            audio.volume = 1;
            audio.play();
			break;
		case 'puddi':
			e.style.bottom = "50px";
			e.style.width = "312px";
			e.style.height = "200px";
			e.style.backgroundSize = "contain";
			var i = document.getElementById("AJb6wCJLMw");
			i.style.backgroundImage = "url('https://orig00.deviantart.net/f91b/f/2010/365/b/7/puddi_puddi_dance_by_waynemccracken-d3633i1.gif')";
            audio.src = '/app/themes/sage/dist/audio/puddipuddi.mp3';
            audio.volume = 1;
            audio.play();
			break;
		case 'rave':
			e.style.width = "480px";
			e.style.height = "400px";
			var i = document.getElementById("AJb6wCJLMw");
			i.style.backgroundImage = "url('https://thumbs.gfycat.com/GoodnaturedRevolvingAsianlion-max-1mb.gif')";
            audio.src = '/app/themes/sage/dist/audio/crab-rave.mp3';
			audio.play();
			break;
		case 'rip':
			e.style.top = "0px";
			e.style.left = "0px";
			e.style.width = "100%";
			e.style.height = "100%";
			var i = document.getElementById("AJb6wCJLMw");
			i.innerHTML = "<h2>RIP</h2>Benedikt<br>Johanna<br>Larissa<br>Oliver<br>Thorsten<br>Tim<br>Tünn<br><h4>Gone but never forgotten!</h4>";
			i.style.padding = "10px";
			i.style.backgroundColor = "black";
			i.style.fontFamily = "Georgia";
			i.style.color = "white";
			i.style.textAlign = "center";
			audio.src = '/app/themes/sage/dist/audio/sadsong.mp3';
			audio.volume = 1;
			audio.play();
			break;
		case 'sans':
			e.style.bottom = "50px";
			e.style.width = "100px";
			e.style.height = "131px";
			e.style.backgroundSize = "contain";
			var i = document.getElementById("AJb6wCJLMw");
			i.style.backgroundImage = "url('https://i.imgur.com/uIg7PBr.png')";
            audio.src = '/app/themes/sage/dist/audio/sans.mp3';
            audio.play();
			break;
		case 'snake':
			e.style.bottom = "50px";
			e.style.width = "207px";
			e.style.height = "334px";
			e.style.backgroundSize = "contain";
			var i = document.getElementById("AJb6wCJLMw");
			i.style.backgroundImage = "url('http://66.media.tumblr.com/6071c0008681c369074f1b4f8041f004/tumblr_n20d2cVrGM1qfnp35o1_r3_250.gif')";
            audio.src = '/app/themes/sage/dist/audio/mgs-snake-scream.mp3';
            audio.play();
			break;
		case 'teppich':
			e.style.bottom = "50px";
			e.style.width = "350px";
			e.style.height = "350px";
			e.style.backgroundSize = "contain";
			var i = document.getElementById("AJb6wCJLMw");
			i.style.backgroundImage = "url('https://thumbs.gfycat.com/VacantPolishedKusimanse-size_restricted.gif')";
            audio.src = '/app/themes/sage/dist/audio/teppichfliegen.mp3'
            audio.volume = 1;
            audio.play();
			break;
		case 'trump':
			e.style.bottom = "50px";
			e.style.width = "300px";
			e.style.height = "300px";
			e.style.backgroundSize = "contain";
			var i = document.getElementById("AJb6wCJLMw");
			i.style.backgroundImage = "url('https://i.gifer.com/X5Nc.gif')";
            audio.src = '/app/themes/sage/dist/audio/usa_anthem.mp3';
            audio.play();
			break;
		case 'walmart':
			e.style.width = "167px";
			e.style.height = "403px";
			var i = document.getElementById("AJb6wCJLMw");
			i.style.backgroundImage = "url('https://i.imgur.com/NjdcB05.gif')";
            audio.src = '/app/themes/sage/dist/audio/walmart_kid.mp3';
			audio.play();
			break;

		default:
			return false;
	}

}

var keys = {
	37: "left",
	38: "up",
	39: "right",
	40: "down",
	65: "a",
	66: "b"
};
var i = ["up", "up", "down", "down", "left", "right", "left", "right", "b", "a"];
var t = 0;
document.addEventListener("keydown", function (o) {
	var a = keys[o.keyCode];
	var d = i[t];
	if (a === d) {
		t++;
		if (t === i.length) {
			var keyword = prompt("Enter keyword (e.g. help)", "");
			switch(keyword) {
				case 'help':
					alert("9\n420\nahrvin\nbongo\ne\ngnome\nheiko\nhoward\nkazoo\noof\npeanut\npuddi\nrave\nrip\nsans\nsnake\nteppich\ntrump\nwalmart");
					break;
				case 'walmart':
					n('walmart');
					break;
				case 'e':
					n('e');
					break;
				case '420':
					n('420');
					break;
				case 'bongo':
					n('bongo');
					break;
				case 'kazoo':
					n('kazoo');
					break;
				case 'oof':
					n('oof');
					break;
				case 'heiko':
					n('heiko');
					break;
				case 'howard':
					n('howard');
					break;
				case 'rip':
					n('rip');
					break;
				case 'sans':
					n('sans');
					break;
				case 'snake':
					n('snake');
					break;
                case 'gnome':
                    n('gnome');
					break;
				case 'puddi':
                    n('puddi');
					break;
				case 'teppich':
                    n('teppich');
                    break;
				case 'trump':
                    n('trump');
					break;
				case 'peanut':
					n('peanut');
					break;
                case '9':
                    n('9');
					break;
				case 'ahrvin':
					n('ahrvin');
					break;
				case 'rave':
					n('rave');
					break;
				default:
					return false;
			}
			t = 0;
		}
	} else {
		t = 0;
	}
});